import React from 'react';

const Footer = () => {
	return (
		<footer>
      <h2>Like it? I'd appreciate some lovin'</h2>
      <div className="icons">
          <a className="share twitter" href="https://twitter.com/home?status=HTML%20meta%20data%20made%20easy%20thanks%20to%20GroovyMeta!%20http://www.groovymeta.com%20@louisotto">Share on Twitter</a>
          <a className="share facebook" href="https://www.facebook.com/sharer/sharer.php?u=http://www.groovymeta.com">Share on Facebook</a>
      </div>
      <p>Built by <a href="https://wingtip.solutions">Louis Otto</a></p>
  	</footer>
	)
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js